import post from '../../../../../fns/http/post'
import getHeaders from '../headers/index'

const loadGeoData = (request, { urls, locale, headers, sessionId, responseProxy }) => {
    return post(`${urls.base.se}/search/geodata`, request, null, getHeaders({ locale, headers }), { responseProxy })
}
export default loadGeoData
